(function ($) {
    // ===== Plugin ======
    $.fn.uploadButton = function (options) {
        const settings = $.extend(true, {
            allowedExtensions: [], // ['jpg','png','pdf'] – [] => tout autoriser
            fileMaxSize: null, // taille maximale par fichier (ex: '5MB' ou bytes)
            totalFilesMaxSize: null, // taille maximale pour tous les fichiers (ex: '20MB' ou bytes)
            uploadedFiles: [], // liste des fichiers deja uploades. File : {name, url, uploadDate}
            maxFiles: null, // nombre max de fichiers - null => illimite
            locale: "fr", // langue utilisee pour les messages
            rejectInvalidFiles: false, // false => les fichiers sont acceptés mais marqués en erreur. true => les fichiers ne sont pas acceptés.
            removeAccentsInFileName: true, // true => pour supprimer les accents dans les noms de fichiers
            removeSpacesInFileName: true, // true => pour supprimer les espaces dans les noms de fichiers
            removeSpecialCharsInFileName: true, // true => pour supprimer les caracteres indesirables dans les noms de fichiers
            hideUploadButtonOnMaxFilesReached: false, // true => pour cacher le boutton d'upload lorsque le nombre de fichiers est supérieur ou égale au nombre max de fichiers autorisés
            messages: { // messages avec des variables de contexte sous forme de placeholders: {{key:value}}
                en: {
                    actionDelete: "Delete",
                    actionDeleteFile: "Delete {{data:fileName}}",
                    buttonTitle: "Upload {{data:isMultiple, pluralRule:{one: 'a file', other: 'files'}}}",
                    buttonDescription: "{{plural:allowedExtensions, joinWord:'or'}} of less than {{data:fileMaxSize}}",
                    errorDuplicateFile: "Duplicate file",
                    errorFileNotSupported: "The accepted files formats are {{data:allowedExtensions, joinWord:'or'}}",
                    errorFileSizeExceeded: "File too large ({{data:fileSize}})",
                    errorInTheFiles: "{{data:totalFilesInError}} {{data:totalFilesInError, pluralRule:{one: 'file is', other: 'files are'}}} not compliant",
                    errorMaxFilesExceeded: "The maximum number of files is {{data:maxFiles}} - (currently {{data:totalFiles}})",
                    errorTotalFilesSizeExceeded: "The maximum size for all files is {{data:totalFilesMaxSize}} - (currently {{data:totalFilesSize}})",
                    fileSentOn: "Sent {{data:fileUploadDate, dateFormat:{yesterday: 'yesterday at  HH:mm', today: 'at  HH:mm', default:'on YYYY/MM/DD at HH:mm'}}}",
                    fileUploaded: "Uploaded {{data:fileUploadDate, dateFormat:{default:'at HH:mm'}}} ({{data:fileSize}})",
                    fileUploading: "Uploading ({{data:fileSize}})",
                    invalidDate: "Invalid date",
                    noTemplate: "No message template",
                    statusError: "Status : in error",
                    statusSent: "Status : sent",
                    statusUploaded: "Status : uploaded",
                    statusUploading: "Status : uploading",
                    unlimited: "unlimited"
                },
                fr: {
                    actionDelete: "Supprimer",
                    actionDeleteFile: "Supprimer {{data:fileName}}",
                    buttonTitle: "Choisir {{data:isMultiple, pluralRule:{one: 'un fichier', other: 'des fichiers'}}}",
                    buttonDescription: "{{data:allowedExtensions, joinWord:'ou'}} de moins de {{data:fileMaxSize}}",
                    errorDuplicateFile: "Fichier en double",
                    errorFileNotSupported: "Les formats de fichiers acceptés sont {{data:allowedExtensions, joinWord:'ou'}}",
                    errorFileSizeExceeded: "Fichier trop lourd ({{data:fileSize}})",
                    errorInTheFiles: "{{data:totalFilesInError}} {{data:totalFilesInError, pluralRule:{one: 'fichier est non conforme', other: 'fichiers sont non conformes'}}}",
                    errorMaxFilesExceeded: "Le nombre maximum de fichiers est de {{data:maxFiles}} - (actuellement {{data:totalFiles}})",
                    errorTotalFilesSizeExceeded: "Le poids maximum pour l'ensemble des fichiers est de {{data:totalFilesMaxSize}} - (actuellement {{data:totalFilesSize}})",
                    fileSentOn: "Envoyé {{data:fileUploadDate, dateFormat:{yesterday: 'hier à HH&nbsp;h&nbsp;mm', today: 'à HH&nbsp;h&nbsp;mm', default:'le DD/MM/YYYY à HH&nbsp;h&nbsp;mm'}}}",
                    fileUploaded: "Téléchargé {{data:fileUploadDate, dateFormat:{default:'à HH&nbsp;h&nbsp;mm'}}} ({{data:fileSize}})",
                    fileUploading: "En cours de téléchargement ({{data:fileSize}})",
                    invalidDate: "Date invalide",
                    noTemplate: "Pas de template de message",
                    statusError: "Statut : en erreur",
                    statusSent: "Statut : envoyé",
                    statusUploaded: "Statut : téléchargé",
                    statusUploading: "Statut : en cours de téléchargement",
                    unlimited: "illimité"
                }
            },
            onValidate: null, // (file) : Callback pour la validation personnalisée d'un fichier
            onAccept: null, // (file) : Callback pour la acceptation/validation d'un fichier
            onChange: null, // (filesArray) : Callback sur le changement de l'état interne du compasant
            onDelete: null, // (file, controlledTarget, callback: function) : Callback pour la confirmation de suppression d'un fichier. controlledTarget est un id ou une classe qui identifie le block le confirmation
            onReject: null // (file, error: {reason, message}) : Callback pour le rejet d'un fichier
        }, options || {});

        const errorScopes = {
            component: "uploadButtonComponent"
        }
        const errorReasons = {
            custom: "custom",
            duplicateFile: "errorDuplicateFile",
            filesInEror: "errorInTheFiles",
            fileNotSupported: "errorFileNotSupported",
            fileSizeExceeded: "errorFileSizeExceeded",
            maxFilesExceeded: "errorMaxFilesExceeded",
            totalFilesSizeExceeded: "errorTotalFilesSizeExceeded"
        }
        const fileStatus = {
            error: {
                icon: "icon-warning",
                class: "-error",
                message: "statusError",
            },
            sent: {
                icon: "icon-circled-check",
                class: "-sent",
                message: "statusSent",
            },
            sentReadOnly: {
                icon: "icon-circled-check",
                class: "-read-only",
                message: "statusSent",
            },
            uploaded: {
                icon: "icon-document",
                class: "-uploaded",
                message: "statusUploaded",
            },
            uploading: {
                icon: "icon-wait",
                class: "-uploading",
                message: "statusUploading",
            },
        }
        const allowedExtensions = new Set((settings.allowedExtensions || []).map(e => String(e).toLowerCase()));
        const fileMaxSize = parseSize(settings.fileMaxSize);
        const totalFilesMaxSize = parseSize(settings.totalFilesMaxSize);
        const maxFiles = parseSize(settings.maxFiles);
        const locale = settings.locale || 'en'; // Fallback vers 'en' si settings.locale est undefined

        const resizeObs = new ResizeObserver(entries => {
            for (const { target } of entries) {
                textEllipsis($(target));
            }
        });

        // ===== Helpers =====
        /**
         * Calcule la taille en bytes à partir de l'entrée donnée.
         *
         * @param {string|number|null} input - La chaîne de caractères représentant la taille (par exemple, "10KB", "2MB") ou un nombre représentant directement la taille en bytes. Peut être null.
         * @returns {number} La taille en bytes. Retourne Infinity si l'entrée n'est pas valide.
         */
        function parseSize(input) {
            if (input == null) {
                return Infinity;
            }  

            if (typeof input === 'number') {
                return input;
            } 

            if (typeof input === 'string') {
                const arr = input.trim().toUpperCase().match(/^(\d+(?:\.\d+)?)\s*(B|KB|MB|GB|TB)?$/);
                if (!arr) {
                    return Infinity;
                }
                
                const value = parseFloat(arr[1]);
                const unit = arr[2] || 'B';
                const map = {
                    B: 1,
                    KB: 1024,
                    MB: 1024 ** 2,
                    GB: 1024 ** 3,
                    TB: 1024 ** 4
                };
                return Math.round(value * (map[unit] || 1));
            }
            return Infinity;
        }

        /**
         * Convertit la taille dans un format lisible.
         *
         * @param {number} input - La taille à convertir.
         * @param {boolean} [isFileSize=true] - Indique si l'entrée est une taille de fichier. Par défaut, true.
         * @returns {string} La taille formatée en une chaîne lisible, avec des unités appropriées (par exemple, "10 Ko", "2 Mo").
         */
        function readableSize(input, isFileSize = true) {
            if (!isFinite(input)) {
                return settings.messages[locale].unlimited;
            }

            if (!isFileSize) {
                return input;
            }
                
            const units = ['o', 'Ko', 'Mo', 'Go', 'To'];
            let i = 0;
            let value = input;
            while (value >= 1024 && i < units.length - 1) {
                value /= 1024;
                i++;
            }

            let fixedValue = value >= 100 || value % 1 === 0 ? value.toFixed(0) : value.toFixed(1);

            if ("fr" === locale && fixedValue) {
                fixedValue = String(fixedValue).replace('.', ',');
            }

            return fixedValue + "&nbsp;" + units[i];
        }

        /**
         * Retourne l'extension du fichier.
         *
         * @param {string} name - Le nom du fichier dont l'extension doit être extraite.
         * @returns {string} L'extension du fichier en minuscules, ou une chaîne vide si aucune extension n'est trouvée.
         */
        function extensionOf(name) {
            const arr = String(name).toLowerCase().match(/\.([a-z0-9]+)$/i);
            return arr ? arr[1] : '';
        }

        /**
         * Remplace les caractères spéciaux par leur code HTML.
         *
         * @param {string} str - La chaîne de caractères à échapper.
         * @returns {string} La chaîne de caractères avec les caractères spéciaux remplacés par leurs codes HTML.
         */
        function escapeHtml(str) {
            return String(str)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
        }

        /**
         * Génère un identifiant unique (UUID) basé sur le format 'xxxxyxxx'.
         *
         * @returns {string} Un identifiant unique sous forme de chaîne de caractères.
         */ 
        function uuid() {
            return 'xxxxyxxx'.replace(/[xy]/g, function (c) {
                let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        }

        /**
         * Affiche les éléments d'une liste.
         *
         * @param {Array} list - La liste des éléments à afficher.
         * @param {string} [joinWord] - Le mot à utiliser pour joindre les éléments avant le dernier élément. Si non fourni, les éléments sont séparés par des virgules.
         * @returns {string} Une chaîne de caractères représentant les éléments de la liste, formatée selon les règles spécifiées.
         */
        function listDisplay(list, joinWord) {
            if (!Array.isArray(list) || list.length === 0)
                return "";

            if (list.length === 1)
                return list[0];

            // Si joinWord non fourni, jointure par virgules
            if (!joinWord)
                return list.join(", ");

            if (list.length === 2)
                return list[0] + " " + joinWord + " " + list[1];

            return list.slice(0, -1).join(", ") + " " + joinWord + " " + list[list.length - 1];
        }

        /**
         * Formate les messages suivant les templates.
         *
         * @param {string} template - Le template contenant des placeholders à remplacer. Exemple de template : {{data:extensions,joinWord:ou}} de moins de {{data:size}}
         * @param {Object} data - Un objet contenant les valeurs à insérer dans les placeholders. La forme de l'objet est {placeholder: value, ...}.
         * @returns {string} Le message formaté avec les placeholders remplacés par les valeurs correspondantes.
         */
        function formatMessage(template, data) {
            return template?.replace(/\{\{\s*data:([\w.-]+)(?:,\s*joinWord:\s*['"]([^'"]+)['"])?(?:,\s*pluralRule:\{(?:one:\s*['"]([^'"]+)['"],\s*other:\s*['"]([^'"]+)['"])\})?(?:,\s*dateFormat:\{(?:yesterday:\s*['"]([^'"]*)['"],\s*)?(?:today:\s*['"]([^'"]*)['"],\s*)?default:\s*['"]([^'"]+)['"]\}\s*)?\}\}/g, (_, key, joinWord, singular, plural, yesterdayFormat, todayFormat, defaultFormat) => {
                let value = data[key];
                if (value == null) {
                    return "";
                }

                if (singular && plural) {
                    return (value === 0 || value === 1) ? singular : plural;
                }

                if (defaultFormat && (typeof value === 'string' || typeof value === 'number')) {
                    const date = new Date(value);
                    if (isNaN(date.getTime())) {
                        return settings.messages[locale].invalidDate;
                    }

                    const now = new Date();
                    const day = String(date.getDate()).padStart(2, '0');
                    const month = String(date.getMonth() + 1).padStart(2, '0');
                    const year = date.getFullYear();
                    const hours = String(date.getHours()).padStart(2, '0');
                    const minutes = String(date.getMinutes()).padStart(2, '0');
                    const seconds = String(date.getSeconds()).padStart(2, '0');

                    if (todayFormat && date.toDateString() === now.toDateString()) {
                        return todayFormat.toLowerCase().replace('hh', hours).replace('mm', minutes).replace('ss', seconds);
                    } else if (yesterdayFormat && new Date(now.setDate(now.getDate() - 1)).toDateString() === date.toDateString()) {
                        return yesterdayFormat.toLowerCase().replace('hh', hours).replace('mm', minutes).replace('ss', seconds);
                    } else {
                        return defaultFormat.replace(/DD|dd|JJ|jj/g, day)
                            .replace(/MM/g, month)
                            .replace(/YYYY|yyyy|AAAA|aaaa/g, year)
                            .replace(/HH|hh/g, hours)
                            .replace(/mm/g, minutes)
                            .replace(/SS|ss/g, seconds);
                    }
                }

                if (Array.isArray(value)) {
                    const arr = value.map(v => String(v));
                    return listDisplay(arr, joinWord);
                }

                return String(value);
            }) || settings.messages[locale].noTemplate;
        }

        /**
         * Tronque les noms de fichier longs en ajoutant une ellipse avant l'extension.
         *
         * @param {jQuery} $filename - L'élément jQuery contenant le titre à tronquer.
         */
        function textEllipsis($filename){
            const $link = $filename.find(".a-link").eq(0);
            const isOverflow = $link[0]?.scrollWidth > $filename[0].clientWidth;
            $filename.toggleClass("-ellipsis", isOverflow);
        }

        /**
         * Supprime les caractères indésirables dans une chaîne.
         *
         * @param {string} str - La chaîne de caractères à nettoyer.
         * @returns {string} La chaîne de caractères nettoyée avec les caractères indésirables remplacés par des underscores.
         */
        function sanitize(str) {
            if (!settings.removeAccentsInFileName && !settings.removeSpecialCharsInFileName && !settings.removeSpacesInFileName) {
                return str;
            }

            let sanitizedStr = str;

            if (settings.removeAccentsInFileName && settings.removeSpecialCharsInFileName) {
                // Remplacer les caractères accentués par leur équivalent sans accent
                sanitizedStr = sanitizedStr.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                // Remplacer les caractères invalides par des underscores
                sanitizedStr = sanitizedStr.replace(/[^a-zA-Z0-9_\-.]/g, '_');
            } else if (settings.removeAccentsInFileName) {
                // Remplacer les caractères accentués par leur équivalent sans accent
                sanitizedStr = sanitizedStr.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
            } else if (settings.removeSpecialCharsInFileName) {
                // Remplacer les caractères invalides par des underscores
                sanitizedStr = sanitizedStr.replace(/[^a-zA-ZÀ-ÿ0-9_\-.]/g, '_');
            }

            if (settings.removeSpacesInFileName) {
                // Remplacer les espaces par des underscores
                sanitizedStr = sanitizedStr.replace(/\s+/g, '_');
            }

            // Remplacer les underscores consécutifs par un seul underscore
            sanitizedStr = sanitizedStr.replace(/_+/g, '_');

            // Enlever l'underscore au début de la chaîne si présent
            if (sanitizedStr.startsWith('_')) {
                sanitizedStr = sanitizedStr.slice(1);
            }

            return sanitizedStr;
        }

        /**
         * Définit le texte et la description du bouton d'upload'.
         *
         * @param {jQuery} $uploadBtnTitle - L'élément jQuery représentant le titre du bouton d'upload'.
         * @param {jQuery} $uploadBtnDesc - L'élément jQuery représentant la description du bouton d'upload'.
         */
        function setUploadButton($uploadBtnTitle, $uploadBtnDesc, isMultiple) {
            const msgData = setMessageData();
            msgData["isMultiple"] = (!isMultiple || maxFiles === 1) ? 1 : 2;
            if ($uploadBtnTitle && settings.messages[locale].buttonTitle) {
                $uploadBtnTitle.html(formatMessage(settings.messages[locale].buttonTitle, msgData));
            }
            if ($uploadBtnDesc && settings.messages[locale].buttonDescription) {
                $uploadBtnDesc.html(formatMessage(settings.messages[locale].buttonDescription, msgData));
            }
        }

        /**
         * Définit les paramètres des messages d'erreur.
         *
         * @param {Object} file - L'objet fichier contenant les informations sur le fichier.
         * @param {string} [file.name] - Le nom du fichier.
         * @param {number} [file.size] - La taille du fichier en bytes.
         * @param {string} [file.uploadDate] - La date de téléchargement du fichier.
         * @returns {Object} Un objet contenant les paramètres des messages d'erreur formatés.
         * @returns {string} return.fileExt - L'extension du fichier avec un point devant.
         * @returns {string} return.fileSize - La taille du fichier formatée en une chaîne lisible.
         * @returns {string} return.fileName - Le nom du fichier échappé pour HTML.
         * @returns {string} return.fileUploadDate - La date de téléchargement du fichier, ou "jj/mm/aaaa" si non définie.
         * @returns {Array<string>} return.allowedExtensions - Les extensions de fichiers autorisées en majuscules.
         * @returns {string} return.maxFiles - Le nombre maximum de fichiers autorisés, formaté en une chaîne lisible.
         * @returns {string} return.fileMaxSize - La taille maximale d'un fichier, formatée en une chaîne lisible.
         * @returns {string} return.totalFilesMaxSize - La taille maximale totale des fichiers, formatée en une chaîne lisible.
         */
        function setMessageData(file) {
            return {
                fileExt: `.${extensionOf(file?.name || "")}`,
                fileSize: readableSize(file?.size || 0),
                fileName: sanitize(escapeHtml(file?.name || "")),
                fileUploadDate: file?.uploadDate || "",
                allowedExtensions: (settings.allowedExtensions || []).map(e => String(e).toUpperCase()),
                maxFiles: readableSize(maxFiles, false),
                fileMaxSize: readableSize(fileMaxSize),
                totalFilesMaxSize: readableSize(totalFilesMaxSize)
           };
        }

        /**
         * Ajoute ou supprime la classe "-error" sur le composant en fonction de l'état des erreurs.
         *
         * @param {jQuery} $component - L'élément jQuery représentant le composant.
         * @param {Object} state - L'objet d'état contenant les informations sur les erreurs.
         * @param {Set} state.errors - Un ensemble (Set) contenant les erreurs actuelles.
         */
        function updateErrorStatus($component, state) {
            $component.toggleClass("-error", state.errors.size > 0);
        }

        /**
         * Calcule la taille totale des fichiers dans la mémoire (input).
         *
         * @param {Object} state - L'objet d'état contenant les informations sur les fichiers.
         * @param {Array<Object>} state.files - Un tableau d'objets représentant les fichiers, chacun ayant une propriété `size` indiquant la taille du fichier en bytes.
         * @returns {number} La taille totale des fichiers en bytes.
         */
        function currentTotalFilesSize(state) {
            return state.files.reduce((sum, file) => sum + file.size, 0);
        }

        /**
         * Valide la structure des fichiers uploadés.
         *
         * @param {Object} entry - L'objet représentant une entrée uploadée.
         * @param {string} entry.name - Le nom du fichier.
         * @param {string} entry.url - L'URL du fichier.
         * @param {string} entry.uploadDate - La date de téléchargement du fichier.
         * @returns {boolean} Retourne `true` si l'entrée est valide, sinon `false`.
         */
        function isValidUploadedEntry(entry) {
            return entry && typeof entry.name === "string" && typeof entry.url === "string" && typeof entry.uploadDate === "string";
        }

        /**
         * Vérifie si une chaîne de caractères représente une date valide.
         *
         * @param {string} dateString - La chaîne de caractères à vérifier.
         * @returns {boolean} - Retourne `true` si la date est valide, sinon `false`.
         */
        function isValidDate(dateString) {
            const date = new Date(dateString);
            return !isNaN(date.getTime());
        }

        /**
         * Trie les fichiers uploadés par date d'upload du plus ancien au plus récent.
         * Les fichiers avec des dates invalides sont placés à la fin de la liste.
         *
         * @param {Object} state - L'état contenant la liste des fichiers uploadés.
         * @param {Array<Object>} state.uploadedFiles - La liste des fichiers uploadé.
         * @param {string} state.uploadedFiles[].name - Le nom du fichier.
         * @param {string} state.uploadedFiles[].url - L'URL du fichier.
         * @param {string} state.uploadedFiles[].uploadDate - La date d'upload du fichier.
         */
        function sortUploadedFiles(state) {
            state.uploadedFiles?.sort((a, b) => {
                if (!isValidDate(a.uploadDate)) {
                    return 1; // Place le fichier invalid à la fin
                }
                if (!isValidDate(b.uploadDate)) {
                    return -1; // Place le fichier invalid à la fin
                }
                return new Date(a.uploadDate) - new Date(b.uploadDate);
            });
        }

        /**
         * Crée une erreur avec une raison et un message.
         *
         * @param {string} reason - La raison de l'erreur.
         * @param {string} message - Le message d'erreur.
         * @returns {Object} Un objet représentant l'erreur, contenant les propriétés `reason` et `message`.
         * @returns {string} return.reason - La raison de l'erreur.
         * @returns {string} return.message - Le message d'erreur.
         */
        function createError(reason, message) {
            return {reason, message};
        }

        /**
         * Crée un objet représentant un fichier uploadé.
         *
         * @param {string} name - Le nom du fichier.
         * @param {string} url - L'URL du fichier.
         * @param {string} uploadDate - La date de téléchargement du fichier.
         * @returns {Object} Un objet représentant le fichier uploadé, contenant les propriétés `name`, `url`, et `uploadDate`.
         * @returns {string} return.name - Le nom du fichier.
         * @returns {string} return.url - L'URL du fichier.
         * @returns {string} return.uploadDate - La date de téléchargement du fichier.
         */
        function createUploadedFile(name, url, uploadDate) {
            return {name, url, uploadDate};
        }

        /**
         * Émet une mise à jour de la liste des fichiers contenus dans la mémoire de l'input.
         *
         * @param {Object} state - L'objet d'état contenant les informations sur les fichiers.
         * @param {Array<Object>} state.files - Un tableau d'objets représentant les fichiers.
         */
        function emitChange(state) {
            if (typeof settings.onChange === 'function') {
                settings.onChange([...state.files]);
            }
        }

        /**
         * Emet un rejet du fichier et alimente le callback `onReject`.
         *
         * @param {Object} file - L'objet représentant le fichier rejeté.
         * @param {Object} error - L'objet représentant l'erreur qui a causé le rejet.
         */
        function emitReject(file, error) {
            if (typeof settings.onReject === 'function') {
                settings.onReject(file, error);
            }
        }

        /**
         * Reconstruit l'input sur la base des fichiers en mémoire.
         *
         * @param {jQuery} $input - L'élément jQuery représentant l'input de fichier.
         * @param {Object} state - L'objet d'état contenant les informations sur les fichiers.
         * @param {Array<File>} state.files - Un tableau d'objets File représentant les fichiers en mémoire.
         */
        function rebuildInputFiles($input, state) {
            const dt = new DataTransfer();
            state.files.forEach(f => dt.items.add(f));
            $input[0].files = dt.files;
        }

        /**
         * Vérifie les restrictions sur le fichier.
         *
         * @param {Object} state - L'objet d'état contenant les informations sur les fichiers.
         * @param {Array<Object>} state.files - Un tableau d'objets représentant les fichiers en mémoire.
         * @param {Map<Object, Array<Object>>} state.errors - Une carte (Map) contenant les erreurs associées à chaque fichier.
         * @param {Object} file - L'objet représentant le fichier à vérifier.
         * @param {string} file.name - Le nom du fichier.
         * @param {number} file.size - La taille du fichier en bytes.
         * @param {number} file.lastModified - La date de dernière modification du fichier.
         * @returns {Promise<boolean>} Retourne `true` si le fichier est valide, sinon `false`.
         */
        async function checkFile(state, file) {
            const ext = extensionOf(file.name);
            const msgData = setMessageData(file);
            const errors = [];
            let error;

            // Verification des fichiers en doublon
            if (state.files.some(f => f.name === file.name && f.size === file.size && f.lastModified === file.lastModified)) {
                error = createError(errorReasons.duplicateFile, formatMessage(settings.messages[locale][errorReasons.duplicateFile], msgData));
                errors.push(error);

                if (settings.rejectInvalidFiles) {
                    emitReject(file, error);
                    return false;
                }
            }

            // Verification de l'extension
            if (allowedExtensions.size && !allowedExtensions.has(ext)) {
                error = createError(errorReasons.fileNotSupported, formatMessage(settings.messages[locale][errorReasons.fileNotSupported], msgData));
                errors.push(error);

                if (settings.rejectInvalidFiles) {
                    emitReject(file, error);
                    return false;
                }
            }

            // Verification du poids du fichier
            if (isFinite(fileMaxSize) && file.size > fileMaxSize) {
                error = createError(errorReasons.fileSizeExceeded, formatMessage(settings.messages[locale][errorReasons.fileSizeExceeded], msgData));
                errors.push(error);

                if (settings.rejectInvalidFiles) {
                    emitReject(file, error);
                    return false;
                }
            }

            // Custom validation
            if (typeof settings.onValidate === 'function') {
                const customValidationResult = settings.onValidate(file);

                // Handle both sync and async cases
                const customErrors = customValidationResult instanceof Promise
                    ? await customValidationResult
                    : customValidationResult;

                // Handle both single error and array of errors
                const errorsArray = Array.isArray(customErrors) ? customErrors : [customErrors];

                for (const customError of errorsArray) {
                    if (customError) {
                        error = createError(errorReasons.custom, customError);
                        errors.push(error);

                        if (settings.rejectInvalidFiles) {
                            emitReject(file, error);
                            return false;
                        }
                    }
                }
            }

            file.uploadDate = (new Date()).toISOString();
            state.files.push(file);
            errors.length && state.errors.set(file, errors);
            !errors.length && settings.onAccept && settings.onAccept(file);
            return true;
        }

        /**
         * Récupère les fichiers nouvellement chargés dans l'input.
         *
         * @param {jQuery} $uploadComponent - L'élément jQuery représentant le composant d'upload.
         * @param {jQuery} $uploadCard - L'élément jQuery représentant la carte du composant upload.
         * @param {jQuery} $uploadBtn - L'élément jQuery représentant le bouton d'upload.
         * @param {jQuery} $input - L'élément jQuery représentant l'input de fichier.
         * @param {jQuery} $fileList - L'élément jQuery représentant la liste des fichiers.
         * @param {jQuery} $errorMessage - L'élément jQuery représentant le message d'erreur.
         * @param {string} errorMessageId - L'identifiant du message d'erreur.
         * @param {Object} state - L'objet d'état contenant les informations sur les fichiers.
         * @param {Array<File>} files - Un tableau d'objets File représentant les fichiers nouvellement chargés.
         */
        async function handleFiles($uploadComponent, $uploadCard, $uploadBtn, $input, $fileList, $errorMessage, errorMessageId, state, files) {
            // Reinitialisation de la memoire en cas de selection de fichier unique
            if (!$input.is('[multiple]')) {
                state.files.forEach(file => {
                    const url = state.urls.get(file);
                    if (url) {
                        URL.revokeObjectURL(url);
                    }
                });
                state.urls.clear();
                state.errors.clear();
                state.files = [];
            }

            let accepted = 0;
            for (let i = 0; i < files.length; i++) {
                if (await checkFile(state, files[i])) {
                    accepted++;
                }
            }

            if (accepted > 0) {
                rebuildInputFiles($input, state);
                renderFileList($uploadComponent, $uploadCard, $uploadBtn, $input, $fileList, $errorMessage, errorMessageId, state);
                emitChange(state);
            }
        }

        /**
         * Ajoute ou supprime un ID dans la liste des IDs de l'attribut `aria-describedby`.
         *
         * @param {jQuery} $elt - L'élément jQuery dont l'attribut `aria-describedby` doit être modifié.
         * @param {string} id - L'ID à ajouter ou supprimer.
         * @param {boolean} status - Le statut indiquant si l'ID doit être ajouté (`true`) ou supprimé (`false`).
         */
        function toggleAriaDescription($elt, id, status) {
            const currentDesc = $elt.attr("aria-describedby") || "";
            const ids = currentDesc.trim().split(/\s+/).filter(Boolean);
            if (status) {
                if (!ids.includes(id)) {
                    ids.push(id);
                }
            } else {
                const index = ids.indexOf(id);
                if (index !== -1) {
                    ids.splice(index, 1);
                }
            }

            // Mise à jour de l'attribut
            $elt.attr("aria-describedby", ids.join(" "));
        }

        /**
         * Affiche le message d'erreur.
         *
         * @param {jQuery} $uploadCard - L'élément jQuery représentant la carte du composant upload.
         * @param {jQuery} $input - L'élément jQuery représentant l'input de fichier.
         * @param {jQuery} $errorMessage - L'élément jQuery représentant le message d'erreur.
         * @param {string} errorMessageId - L'identifiant du message d'erreur.
         * @param {string} msg - Le message d'erreur à afficher.
         */
        function renderErrorMessage($uploadCard, $input, $errorMessage, errorMessageId, msg) {
            toggleAriaDescription($input, errorMessageId, true);
            $errorMessage.find('.a-paragraph').eq(0).attr("id", errorMessageId);
            $errorMessage.find('.-message').eq(0).empty().html(msg);
            $errorMessage.insertAfter($uploadCard);
        }

        /**
         * Supprime le message d'erreur.
         *
         * @param {jQuery} $input - L'élément jQuery représentant l'input de fichier.
         * @param {jQuery} $errorMessage - L'élément jQuery représentant le message d'erreur.
         * @param {string} errorMessageId - L'identifiant du message d'erreur.
         */
        function hideErrorMessage($input, $errorMessage, errorMessageId) {
            toggleAriaDescription($input, errorMessageId, false);
            $errorMessage.remove();
        }

        /**
         * Construit l'affichage d'un fichier dans la liste.
         *
         * @param {string} fileName - Le nom du fichier.
         * @param {string} fileUrl - L'URL du fichier.
         * @param {string} descriptionMessage - Le message de description du fichier.
         * @param {Object} itemStatus - L'objet qui représente le statu du fichier.
         * @param {string} itemStatus.icon - L'icone associée au statut du fichier.
         * @param {string} itemStatus.class - La classe css associée au statut du fichier.
         * @param {string} itemStatus.message - La clé du message associée au statut du fichier.
         * @param {Object} msgData - L'objet qui contient les paramètres utilisés dans les messages.
         * @param {jQuery} [$removeBtn] - L'élément jQuery représentant le bouton de suppression (optionnel).
         * @returns {jQuery} L'élément jQuery représentant l'élément de fichier dans la liste.
         */
        function createFileItem(fileName, fileUrl, descriptionMessage, itemStatus, msgData, $removeBtn) {
            const $fileIcon = $(`
                <div class="m-form__uploadCard__filesList__item__status">
                    <span class="icon ${itemStatus.icon} -status" aria-hidden="true"><!-- ${itemStatus.icon} --></span>
                    <span class="sr-only">${formatMessage(settings.messages[locale][itemStatus.message], msgData)}</span>
                </div>
            `);

            const ext = extensionOf(fileName);

            const $filename = $(`<p class="a-paragraph -fileName"${ext !== '' ? ` data-file-ext="${ext}"` : ''}></p>`);
            $filename.html(fileUrl != null 
                ? `<a class="a-link" href="${fileUrl}" target="_blank" title="${fileName}">${fileName}</a>`
                : fileName
            );

            const $fileDescription = descriptionMessage != null ? $('<p class="a-paragraph -fileDescription"></p>').html(descriptionMessage) : '';

            const $item = $(`
                <li class="m-form__uploadCard__filesList__item ${itemStatus.class}">
                    <div class="m-form__uploadCard__filesList__item__texts"></div>
                </li>
            `);

            $item.prepend($fileIcon)
                .find('.m-form__uploadCard__filesList__item__texts')
                .eq(0)
                .append($filename, $fileDescription);

            if ($removeBtn) {
                $item.append($removeBtn);
            }

            return $item;
        }

        /**
         * Affiche un message global de status de fichiers déjà uploadés.
         *
         * @param {jQuery} $fileList - L'élément jQuery représentant la liste des fichiers.
         * @param {Object} state - L'objet d'état contenant les informations sur les fichiers.
         * @param {Array<Object>} state.uploadedFilesStatusMessage - Un message sur le statut des fichiers déjà uploadés.
         */
        function renderUploadedFilesStatusMessage($fileList, state) {
            if (state.uploadedFilesStatusMessage != null && state.uploadedFilesStatusMessage !== '') {
                $fileList.append(createFileItem(state.uploadedFilesStatusMessage, null, null, fileStatus.sentReadOnly));
            }
        }

        /**
         * Affiche la liste des fichiers déjà uploadés.
         *
         * @param {jQuery} $fileList - L'élément jQuery représentant la liste des fichiers.
         * @param {Object} state - L'objet d'état contenant les informations sur les fichiers.
         * @param {Array<Object>} state.uploadedFiles - Un tableau d'objets représentant les fichiers déjà uploadés.
         */
        function renderUploadedFiles($fileList, state) {
            state.uploadedFiles.forEach((file) => {
                const msgData = setMessageData(file);
                const descriptionMessage = formatMessage(settings.messages[locale].fileSentOn, msgData);

                $fileList.append(createFileItem(file.name, file.url, descriptionMessage, fileStatus.sent, msgData));
            });
        }

        /**
         * Supprime un fichier de la liste des fichiers à uploader.
         * 
         * @param {jQuery} $uploadComponent - L'élément jQuery représentant le composant d'upload.
         * @param {jQuery} $uploadCard - L'élément jQuery représentant la carte du composant upload.
         * @param {jQuery} $uploadBtn - L'élément jQuery représentant le bouton d'upload.
         * @param {jQuery} $input - L'élément jQuery représentant l'input de fichier.
         * @param {jQuery} $fileList - L'élément jQuery représentant la liste des fichiers.
         * @param {jQuery} $errorMessage - L'élément jQuery représentant le message d'erreur.
         * @param {string} errorMessageId - L'identifiant du message d'erreur.
         * @param {Object} state - L'objet d'état contenant les informations sur les fichiers.
         * @param {Object} file - Le fichier à supprimer.
         * @param {number} fileIndex - L'index du fichier dans le tableau des fichiers à uploader.
         */
        function deleteFile($uploadComponent, $uploadCard, $uploadBtn, $input, $fileList, $errorMessage, errorMessageId, state, file, fileIndex) {
            const url = state.urls.get(file);
            const error = state.errors.get(file);

            if (url) {
                URL.revokeObjectURL(url);
                state.urls.delete(file);
            }

            if (error) {
                state.errors.delete(file);
            }

            state.files.splice(fileIndex, 1);
            rebuildInputFiles($input, state);
            renderFileList($uploadComponent, $uploadCard, $uploadBtn, $input, $fileList, $errorMessage, errorMessageId, state);
            emitChange(state);
        }

        /**
         * Affiche la liste des fichiers.
         *
         * @param {jQuery} $uploadComponent - L'élément jQuery représentant le composant d'upload.
         * @param {jQuery} $uploadCard - L'élément jQuery représentant la carte du composant upload.
         * @param {jQuery} $uploadBtn - L'élément jQuery représentant le bouton d'upload.
         * @param {jQuery} $input - L'élément jQuery représentant l'input de fichier.
         * @param {jQuery} $fileList - L'élément jQuery représentant la liste des fichiers.
         * @param {jQuery} $errorMessage - L'élément jQuery représentant le message d'erreur.
         * @param {string} errorMessageId - L'identifiant du message d'erreur.
         * @param {Object} state - L'objet d'état contenant les informations sur les fichiers.
         * @param {Array<Object>} state.files - Un tableau d'objets représentant les fichiers en mémoire.
         * @param {Array<Object>} state.uploadedFiles - Un tableau d'objets représentant les fichiers déjà uploadés.
         * @param {Map<Object, string>} state.urls - Une carte (Map) contenant les URLs des fichiers.
         * @param {Map<Object, Array<Object>>} state.errors - Une carte (Map) contenant les erreurs associées à chaque fichier.
         */
        function renderFileList($uploadComponent, $uploadCard, $uploadBtn, $input, $fileList, $errorMessage, errorMessageId, state) {
            let componentErrors = state.errors.get(errorScopes.component) || [];
            componentErrors = componentErrors.filter(error => error.reason === errorReasons.custom);
            if (!state.files.length && !componentErrors.length) {
                state.errors.delete(errorScopes.component);
                hideErrorMessage($input, $errorMessage, errorMessageId);
                updateErrorStatus($uploadComponent, state);
            }

            if (!state.files.length && !state.uploadedFiles.length && (state.uploadedFilesStatusMessage == null || state.uploadedFilesStatusMessage === '')) {
                $fileList.remove();
                return;
            }

            $fileList.empty();
            renderUploadedFilesStatusMessage($fileList, state);
            renderUploadedFiles($fileList, state);

            let removeBtnControlTarget = $uploadComponent.data('control-delete-target') || "";

            state.files.forEach((file, idx) => {
                const msgData = setMessageData(file);

                let itemStatus = fileStatus.uploaded;
                let descriptionMessage = formatMessage(settings.messages[locale].fileUploaded, msgData);
                let url = state.urls.get(file);
                let error = state.errors.get(file);
                if (!url) {
                    url = URL.createObjectURL(file);
                    state.urls.set(file, url);
                }

                if (error) {
                    itemStatus = fileStatus.error;
                    descriptionMessage = error[0]?.message || "";
                }

                const $removeBtn = $(`
                    <button class="a-btn -icon -delete" type="button" title="${settings.messages[locale].actionDelete}">
                        <span class="icon icon-trash" aria-hidden="true"><!-- trash icon --></span>
                        <span class="sr-only">${formatMessage(settings.messages[locale].actionDeleteFile, msgData)}</span>
                    </button>
                `);
                $removeBtn.on('click keydown', function (e) {
                    if (e.type === 'click' || (e.type === 'keydown' && (e.key === 'Enter' || e.key === ' '))) {
                        e.stopPropagation(); // Empêche la propagation de l'événement
                        // Appeler le callback de suppression si fourni
                        if (typeof settings.onDelete === 'function') {
                            settings.onDelete(file, removeBtnControlTarget, function (confirmed) {
                                if (confirmed) {
                                    deleteFile($uploadComponent, $uploadCard, $uploadBtn, $input, $fileList, $errorMessage, errorMessageId, state, file, idx);
                                }
                            });
                        } else {
                            // Fallback
                            deleteFile($uploadComponent, $uploadCard, $uploadBtn, $input, $fileList, $errorMessage, errorMessageId, state, file, idx);
                        }
                    }
                });

                if (removeBtnControlTarget.length) {
                    $removeBtn.attr("aria-controls", removeBtnControlTarget);
                }

                $fileList.append(createFileItem(sanitize(file.name), url, descriptionMessage, itemStatus, msgData, $removeBtn));
            });

            // Insertion de la liste de fichier dans le DOM
            $uploadCard.prepend($fileList);

            // Applique l'ellipse sur les noms de fichier
            const fileNames = $uploadCard.find(".-fileName");
            fileNames.each((index, el) => {
                textEllipsis($(el));
                resizeObs.observe(el);
            });

            const msgData = setMessageData();
            const totalFiles = state.uploadedFiles.length + state.files.length;

            // Compte le nombre de fichier en erreur
            let totalFilesInError = 0;
            for (let [key, value] of state.errors) {
                if (key !== errorScopes.component) {
                    totalFilesInError++;
                }
            }

            // Verification des erreurs sur les fichiers
            if (totalFilesInError > 0) {
                msgData.totalFilesInError = totalFilesInError;
                componentErrors.push(createError(errorReasons.filesInEror, formatMessage(settings.messages[locale][errorReasons.filesInEror], msgData)));
            }

            // Verification du nombre total des fichiers
            if (isFinite(maxFiles) && totalFiles > maxFiles) {
                msgData.totalFiles = totalFiles;
                componentErrors.push(createError(errorReasons.maxFilesExceeded, formatMessage(settings.messages[locale][errorReasons.maxFilesExceeded], msgData)));
            }

            if (settings.hideUploadButtonOnMaxFilesReached && isFinite(maxFiles) && totalFiles >= maxFiles) {
                //$uploadBtn.hide();
                $uploadBtn.detach();
                $uploadComponent.addClass("-hiddenButton");
            } else {
                //$uploadBtn.show();
                $uploadCard.append($uploadBtn);
                $uploadComponent.removeClass("-hiddenButton");
            }

            // Verification du poids total des fichiers
            const totalFilesSize = currentTotalFilesSize(state);
            if (isFinite(totalFilesMaxSize) && totalFilesSize > totalFilesMaxSize) {
                msgData.totalFilesSize = readableSize(totalFilesSize);
                componentErrors.push(createError(errorReasons.totalFilesSizeExceeded, formatMessage(settings.messages[locale][errorReasons.totalFilesSizeExceeded], msgData)));
            }

            // Ajout/Suppression du message d'erreur global du composant
            if (componentErrors.length) {
                state.errors.set(errorScopes.component, componentErrors);
                renderErrorMessage($uploadCard, $input, $errorMessage, errorMessageId, (componentErrors[0]?.message || ""));
            } else {
                state.errors.delete(errorScopes.component);
                hideErrorMessage($input, $errorMessage, errorMessageId);
            }

            // Mise a jour du statut de uploadComponent
            updateErrorStatus($uploadComponent, state);
        }

        return this.each(async function () {
            const $input = $(this);
            // Si input déjà initialisé, ne rien faire
            if ($input.data('uploadButtonInitialized')) {
                return;
            }

            const $uploadBtn = $input.closest('.m-form__uploadCard__button');
            const $uploadComponent = $uploadBtn.closest('.m-form.-uploadButton');
            const $uploadCard = $uploadBtn.closest('.m-form__uploadCard');
            const $uploadBtnTitle = $uploadBtn.find('.-buttonTitle').eq(0);
            const $uploadBtnDesc = $uploadBtn.find('.-buttonDescription').eq(0);
            const $fileList = $('<ul class="m-form__uploadCard__filesList"></ul>');
            const errorMessageId = ($input.attr("id") || "input-file") + `-${uuid()}-error`;
            const $errorMessage = $(`
                <div class="m-form__errorMessage">
                    <p class="a-paragraph -icon -error">
                        <span class="icon icon-warning" aria-hidden="true"><!-- warning icon- --></span>
                        <span class="-message"></span>
                    </p>
                </div>
            `);

            // Memoire interne du composant upload
            let state = {
                files: [],
                uploadedFiles: [],
                urls: new Map(),
                errors : new Map(),
                uploadedFilesStatusMessage: null
            };

            // Initialisation des fichiers uploades en memoire
            if (Array.isArray(settings.uploadedFiles)) {
                state.uploadedFiles = settings.uploadedFiles.filter(isValidUploadedEntry).map(entry => createUploadedFile(entry.name, entry.url, entry.uploadDate));
                sortUploadedFiles(state);
            }

            // Initialisation des fichiers à uploader en memoire
            if (this.files) {
                await handleFiles($uploadComponent, $uploadCard, $uploadBtn, $input, $fileList, $errorMessage, errorMessageId, state, this.files);
            }

            // listener sur input change
            $input.on('change', async function () {
                await handleFiles($uploadComponent, $uploadCard, $uploadBtn, $input, $fileList, $errorMessage, errorMessageId, state, this.files);
             });

            // API
            $input.data('uploadButton', {
                /**
                 * Desactive l'input en ajoutant l'attribut 'disabled'.
                 */
                disable: () => $input.attr('disabled', 'disabled'),

                /**
                 * Active l'input en supprimant l'attribut 'disabled'.
                 */
                enable: () => $input.removeAttr('disabled'),

                /**
                 * Verifie si l'input est desactive.
                 * @returns {boolean} True si l'input est desactive, sinon false.
                 */
                isDisabled: () => $input.is(':disabled'),

                /**
                 * Véerifie si l'input est active.
                 * @returns {boolean} True si l'input est active, sinon false.
                 */
                isEnabled: () => !$input.is(':disabled'),

                /**
                 * Vérifie s'il y a des erreurs dans le composant.
                 * @returns {boolean} True s'il y a des erreurs, sinon false.
                 */
                hasErrors: () => state.errors.size > 0,

                /**
                 * Masque le bouton d'upload, mais pas la liste des fichiers
                 */
                hideUploadButton: () => {
                    //$uploadBtn.hide();
                    $uploadBtn.detach();
                    $uploadComponent.addClass("-hiddenButton");
                },

                /**
                 * Affiche le button d'upload
                 */
                showUploadButton: () => {
                    //$uploadBtn.show();
                    $uploadCard.append($uploadBtn);
                    $uploadComponent.removeClass("-hiddenButton");
                },

                /**
                 * Ajoute un fichier a la liste des fichiers deja uploades.
                 * @param {Object} entry - L'entree du fichier a ajouter.
                 */
                addUploadedFile: (entry) => {
                    if (isValidUploadedEntry(entry)) {
                        state.uploadedFiles.push(createUploadedFile(entry.name, entry.url, entry.uploadDate));
                        sortUploadedFiles(state);
                        renderFileList($uploadComponent, $uploadCard, $uploadBtn, $input, $fileList, $errorMessage, errorMessageId, state);
                    }
                },

                /**
                 * Ajoute un message d'erreur global personnalise au composant.
                 * @param {string} msg - Le message d'erreur a ajouter.
                 */
                setCustomGlobalErrorMessage: (msg) => {
                    let componentErrors = state.errors.get(errorScopes.component) || [];
                    componentErrors = [createError(errorReasons.custom, msg), ...componentErrors];
                    state.errors.set(errorScopes.component, componentErrors);
                    renderErrorMessage($uploadCard, $input, $errorMessage, errorMessageId, (componentErrors[0]?.message || ""));
                    updateErrorStatus($uploadComponent, state);
                },

                /**
                 * Met a jour dynamiquement la liste des fichiers deja uploades.
                 * @param {Array} arr - Le tableau des fichiers a mettre a jour.
                 */
                setUploadedFiles: (arr) => {
                    if (Array.isArray(arr)) {
                        state.uploadedFiles = arr.filter(isValidUploadedEntry).map(entry => createUploadedFile(entry.name, entry.url, entry.uploadDate));
                        sortUploadedFiles(state);
                        renderFileList($uploadComponent, $uploadCard, $uploadBtn, $input, $fileList, $errorMessage, errorMessageId, state);
                    }
                },

                /**
                 * Met a jour dynamiquement un message de statut pour les fichiers deja uploades.
                 * @param {msg} String - Le message à afficher.
                 */
                updateUploadedFilesStatusMessage: (msg) => {
                    state.uploadedFilesStatusMessage = msg != null ? String(msg) : null;
                    renderFileList($uploadComponent, $uploadCard, $uploadBtn, $input, $fileList, $errorMessage, errorMessageId, state);
                },

                /**
                 * Retourne la liste des fichiers deja uploades.
                 * @returns {Array} La liste des fichiers deja uploades.
                 */
                getUploadedFiles: () => state.uploadedFiles.map(entry => ({ ...entry })),

                /**
                 * Retourne la liste des fichiers a uploader avec des noms nettoyes.
                 * @returns {Array} La liste des fichiers a uploader.
                 */
                getFilesToUpload: () => {
                    return state.files.map(file => {
                        const sanitizedFilename = sanitize(file.name);
                        return new File([file], sanitizedFilename, { type: file.type });
                    });
                },

                /**
                 * Retourne le poids total des fichiers a uploader.
                 * @returns {number} Le poids total des fichiers a uploader.
                 */
                getFilesToUploadSize: () => currentTotalFilesSize(state),

                /**
                 * Retourne le nombre total de fichiers a uploader.
                 * @returns {number} Le nombre total de fichiers a uploader.
                 */
                getFilesToUploadCount: () => state.files.length,

                /**
                 * Retourne la liste des extensions uniques des fichiers a uploader.
                 * @returns {Array} La liste des extensions uniques.
                 */
                getFilesToUploadExtensions: () => {
                    const exts = new Set();
                    state.files.forEach(file => {
                        const ext = extensionOf(file.name);
                        if (ext) {
                            exts.add(ext);
                        }
                    });
                    return [...exts];
                },

                /**
                 * Retourne la taille maximale autorisee pour l'ensemble des fichiers a uploader.
                 * @returns {number|null} La taille maximale autorisee en bytes ou null si non definie.
                 */
                getTotalFilesMaxSize: () => {
                    if (!isFinite(totalFilesMaxSize)) {
                        return null;
                    }
                    return totalFilesMaxSize;
                },

                /**
                 * Retourne la taille maximale autorisee pour un fichier a uploader.
                 * @returns {number|null} La taille maximale autorisee en bytes ou null si non definie.
                 */
                getFileMaxSize: () => {
                    if (!isFinite(fileMaxSize)) {
                        return null;
                    }
                    return fileMaxSize;
                },

                /**
                 * Retourne la liste des erreurs selon la portee : composant ou fichier
                 * @returns {Array} La liste des erreurs.
                 */
                getErrors: () => Array.from(state.errors, ([key, value]) => ({ scope: key, errors: [...value] })),

                /**
                 * Supprime les messages d'erreur personnalises au niveau du composant.
                 */
                removeCustomGlobalErrorMessage: () => {
                    let componentErrors = state.errors.get(errorScopes.component) || [];
                    componentErrors = componentErrors.filter(error => error.reason !== errorReasons.custom);
                    if (componentErrors.length) {
                        state.errors.set(errorScopes.component, componentErrors);
                        renderErrorMessage($uploadCard, $input, $errorMessage, errorMessageId, (componentErrors[0]?.message || ""));
                    } else {
                        state.errors.delete(errorScopes.component);
                        hideErrorMessage($input, $errorMessage, errorMessageId);
                    }
                    updateErrorStatus($uploadComponent, state);
                },

                /**
                 * Supprime un fichier de la liste des fichiers a uploader selon son index dans la liste.
                 * @param {number} i - L'index du fichier a supprimer.
                 */
                removeFileToUpload: (i) => {
                    if (i >= 0 && i < state.files.length) {
                        const file = state.files[i];
                        const url = state.urls.get(file);
                        const error = state.errors.get(file);
                        if (url) {
                            URL.revokeObjectURL(url);
                            state.urls.delete(file);
                        }
                        if (error) {
                            state.errors.delete(file);
                        }
                        state.files.splice(i, 1);
                        rebuildInputFiles($input, state);
                        renderFileList($uploadComponent, $uploadCard, $uploadBtn, $input, $fileList, $errorMessage, errorMessageId, state);
                        emitChange(state);
                    }
                },

                /**
                 * Vide la liste locale des fichiers a uploader.
                 */
                clearFilesToUpload: () => {
                    state.files.forEach(file => {
                        const url = state.urls.get(file);
                        if (url) {
                            URL.revokeObjectURL(url);
                        }
                    });
                    state.urls.clear();
                    state.errors.clear();
                    state.files = [];
                    rebuildInputFiles($input, state);
                    renderFileList($uploadComponent, $uploadCard, $uploadBtn, $input, $fileList, $errorMessage, errorMessageId, state);
                    emitChange(state);
                },

                /**
                 * Vide la liste des fichiers deja uploades.
                 */
                clearUploadedFiles: () => {
                    state.uploadedFiles = [];
                    renderFileList($uploadComponent, $uploadCard, $uploadBtn, $input, $fileList, $errorMessage, errorMessageId, state);
                },

                /**
                * Détruit le composant uploadButton
                * Supprime tous les événements, nettoie les ressources et réinitialise l'état
                */
                destroy: () => {
                    if ($input.data('uploadButtonInitialized')) {
                        // Supprimer tous les événements liés
                        $input.off('change');

                        // Nettoyer les URLs des fichiers
                        state.files.forEach(file => {
                            const url = state.urls.get(file);
                            if (url) {
                                URL.revokeObjectURL(url);
                            }
                        });

                        // Supprimer les données associées à l'input
                        $input.removeData('uploadButton');
                        $input.removeData('uploadButtonInitialized');

                        // Supprimer les éléments DOM créés
                        $fileList.remove();
                        $errorMessage.remove();

                        // Réinitialiser l'état
                        state = {
                            files: [],
                            uploadedFiles: [],
                            urls: new Map(),
                            errors: new Map()
                        };

                        // Réinitialiser l'input
                        // $input.val('');

                        // Supprimer les classes ajoutées
                        $uploadComponent.removeClass("-hiddenButton -error");

                        // Réafficher le bouton si nécessaire
                        if ($uploadBtn.parent().length === 0) {
                            $uploadCard.append($uploadBtn);
                        }

                        // Supprimer la référence au composant
                        $input.data('uploadButton', null);
                    }
                }
            });

            // Initial render
            $input.data('uploadButtonInitialized', true);
            setUploadButton($uploadBtnTitle, $uploadBtnDesc, $input.is('[multiple]'));
            renderFileList($uploadComponent, $uploadCard, $uploadBtn, $input, $fileList, $errorMessage, errorMessageId, state);
        });
    };
})(jQuery);